import { Repository } from 'src/components/types';
import { fetchAction } from 'src/redux/actions';
import { urls } from 'src/urls/source';

import { LoadLfsInfo } from './';

// eslint-disable-next-line import/no-default-export
export default (repository: Repository, ref: string, path: string) =>
  fetchAction(LoadLfsInfo, {
    url: urls.api.internal.lfsInfo(repository.full_name, ref, path),
  });
